export const selectCopyToNewMessageOldUri = (state) =>
  state.editor.copyToNewMessage.oldUri

export const selectCopyToNewMessageTimestamp = (state) =>
  state.editor.copyToNewMessage.timestamp
